import { useContext, useEffect, useState } from "react";
import FirmContext from "../firms/FirmContext";
import { useTranslation } from "react-i18next";
import {
  initErrorContactState,
  tabStatusInitialValue,
} from "../../pages/Firm/helpers/InitialData";
import userContext from "../users/UserContext";
import { isNumber } from "underscore";
import { validatePhoneNumberWithCode } from "../../helpers/CommonUtility";
import {
  ACTIONS,
  SPECIALCHAR_UNICODE_REGEX,
  TOAST_TYPE,
} from "../../constants/Constants";
import toastContext from "../toast/ToastContext";
import { getEnv } from '../../helpers/EnvHelper';

const FirmState = (props) => {
  let isBucketManagement = (getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == "true" || getEnv("REACT_APP_BUCKET_MANAGEMENT_ENABLED") == true) ? true : false;
  let isEnableWhatsApp =   (getEnv("REACT_APP_ENABLE_WHATSAPP") == "true" || getEnv("REACT_APP_ENABLE_WHATSAPP") == true) ? true : false;

  const [errorContactState, setErrorContactState] = useState(
    initErrorContactState
  );
  const [firmGlobalErrorState, setFirmGlobalErrorState] = useState({});
  const [tabStatus, setTabStatus] = useState(tabStatusInitialValue);
  const { roles } = useContext(userContext);
  const { showToastv2 } = useContext(toastContext);
  const [t] = useTranslation();

  useEffect(()=>{
    console.log("Roles inside the FirmState ================", roles);
        console.log("Roles inside the FirmState 0 ================", roles[0]);

  })
  const emailCorrect = (email) => {
    if (email == "") return true;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i;
    if (!regex.test(email)) {
      return false;
    } else {
      return true;
    }
  };

  const setErrorsContactStatefromGlobalState = () => {
    if (
      firmGlobalErrorState["contact1.name"] ||
      firmGlobalErrorState["contact1.email"] ||
      firmGlobalErrorState["contact1.type"] ||
      firmGlobalErrorState["contact1.mobile"] ||
      firmGlobalErrorState["contact1.landline"]
    )
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (firmGlobalErrorState["contact1.name"]) {
          newVal.contact1.name.error = true;
          newVal.contact1.name.msg = firmGlobalErrorState["contact1.name"];
        }
        if (firmGlobalErrorState["contact1.email"]) {
          newVal.contact1.email.error = true;
          newVal.contact1.email.msg = firmGlobalErrorState["contact1.email"];
        }
        if (firmGlobalErrorState["contact1.type"]) {
          newVal.contact1.type.error = true;
          newVal.contact1.type.msg = firmGlobalErrorState["contact1.type"];
        }
        if (firmGlobalErrorState["contact1.mobile"]) {
          newVal.contact1.mobile.error = true;
          newVal.contact1.mobile.msg = firmGlobalErrorState["contact1.mobile"];
        }
        if (firmGlobalErrorState["contact1.landline"]) {
          newVal.contact1.landline.error = true;
          newVal.contact1.landline.msg =
            firmGlobalErrorState["contact1.landline"];
        }
        newVal.contact1.errorState = true;
        return newVal;
      });

    if (
      firmGlobalErrorState["contact2.name"] ||
      firmGlobalErrorState["contact2.email"] ||
      firmGlobalErrorState["contact2.type"] ||
      firmGlobalErrorState["contact2.mobile"] ||
      firmGlobalErrorState["contact2.landline"]
    ) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (firmGlobalErrorState["contact2.name"]) {
          newVal.contact2.name.error = true;
          newVal.contact2.name.msg = firmGlobalErrorState["contact2.name"];
        }
        if (firmGlobalErrorState["contact2.email"]) {
          newVal.contact2.email.error = true;
          newVal.contact2.email.msg = firmGlobalErrorState["contact2.email"];
        }
        if (firmGlobalErrorState["contact2.type"]) {
          newVal.contact2.type.error = true;
          newVal.contact2.type.msg = firmGlobalErrorState["contact2.type"];
        }
        if (firmGlobalErrorState["contact2.mobile"]) {
          newVal.contact2.mobile.error = true;
          newVal.contact2.mobile.msg = firmGlobalErrorState["contact2.mobile"];
        }
        if (firmGlobalErrorState["contact2.landline"]) {
          newVal.contact2.landline.error = true;
          newVal.contact2.landline.msg =
            firmGlobalErrorState["contact2.landline"];
        }
        newVal.contact2.errorState = true;
        return newVal;
      });
    }

    if (
      firmGlobalErrorState["contact3.name"] ||
      firmGlobalErrorState["contact3.email"] ||
      firmGlobalErrorState["contact3.type"] ||
      firmGlobalErrorState["contact3.mobile"] ||
      firmGlobalErrorState["contact3.landline"]
    )
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (firmGlobalErrorState["contact3.name"]) {
          newVal.contact3.name.error = true;
          newVal.contact3.name.msg = firmGlobalErrorState["contact3.name"];
        }
        if (firmGlobalErrorState["contact3.email"]) {
          newVal.contact3.email.error = true;
          newVal.contact3.email.msg = firmGlobalErrorState["contact3.email"];
        }
        if (firmGlobalErrorState["contact3.type"]) {
          newVal.contact3.type.error = true;
          newVal.contact3.type.msg = firmGlobalErrorState["contact3.type"];
        }
        if (firmGlobalErrorState["contact3.mobile"]) {
          newVal.contact3.mobile.error = true;
          newVal.contact3.mobile.msg = firmGlobalErrorState["contact3.mobile"];
        }
        if (firmGlobalErrorState["contact3.landline"]) {
          newVal.contact3.landline.error = true;
          newVal.contact3.landline.msg =
            firmGlobalErrorState["contact3.landline"];
        }
        newVal.contact3.errorState = true;
        return newVal;
      });
  };

  useEffect(() => {
    if (
      firmGlobalErrorState?.reportLinkExpiryTime ||
      firmGlobalErrorState?.studyLinkExpiryTime
    ) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab6Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
    }

    if (
      firmGlobalErrorState?.priorityCount ||
      firmGlobalErrorState?.branchCode
    ) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab9Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
    }

    if (
      firmGlobalErrorState["contact1.name"] ||
      firmGlobalErrorState["contact2.name"] ||
      firmGlobalErrorState["contact3.name"] ||
      firmGlobalErrorState["contact1.email"] ||
      firmGlobalErrorState["contact2.email"] ||
      firmGlobalErrorState["contact3.email"] ||
      firmGlobalErrorState["contact1.type"] ||
      firmGlobalErrorState["contact2.type"] ||
      firmGlobalErrorState["contact3.type"] ||
      firmGlobalErrorState["contact1.mobile"] ||
      firmGlobalErrorState["contact2.mobile"] ||
      firmGlobalErrorState["contact3.mobile"] ||
      firmGlobalErrorState["contact1.landline"] ||
      firmGlobalErrorState["contact2.landline"] ||
      firmGlobalErrorState["contact3.landline"]
    ) {
      setErrorsContactStatefromGlobalState();
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
    }

    let hospitalDetailsValidationFlag = false;
    if (firmGlobalErrorState?.address) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = firmGlobalErrorState?.address;
        return newVal;
      });
      hospitalDetailsValidationFlag = true;
    }
    if (firmGlobalErrorState?.name) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = firmGlobalErrorState?.name;
        return newVal;
      });
      hospitalDetailsValidationFlag = true;
    }
    if (firmGlobalErrorState?.country) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.country.error = true;
        newVal.hospitalDetails.country.msg = firmGlobalErrorState?.country;
        return newVal;
      });
      hospitalDetailsValidationFlag = true;
    }
    if (firmGlobalErrorState?.state) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.state.error = true;
        newVal.hospitalDetails.state.msg = firmGlobalErrorState?.state;
        return newVal;
      });
      hospitalDetailsValidationFlag = true;
    }
    if (firmGlobalErrorState?.city) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.city.error = true;
        newVal.hospitalDetails.city.msg = firmGlobalErrorState?.city;
        return newVal;
      });
      hospitalDetailsValidationFlag = true;
    }
     if (
      firmGlobalErrorState?.demoFirm ||
      firmGlobalErrorState?.demoExpiryDate ||
      firmGlobalErrorState?.demoExpiryType ||
      firmGlobalErrorState?.maxStudyUploads ||
      firmGlobalErrorState?.demoStudyCount
    ) {
      hospitalDetailsValidationFlag = true;
    }

    if (hospitalDetailsValidationFlag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
    }
  }, [firmGlobalErrorState]);

  const validateHospitalDetails = (values) => {
    const nameRegex = /^[0-9a-zA-Z&._ -]+$/i;
    const addressRegex = /^[0-9a-zA-Z\s&#.\/,-]+$/i;
    let validationFlag = false;
    if (values.name == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t("string-literals.name-empty");
        return newVal;
      });
      validationFlag = true;
    } else if (values.name.length > 100) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t(
          "string-literals.firm-name-length-exceeds"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (!nameRegex.test(values.name)) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t(
          "string-literals.firm-name-invalid"
        );
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = false;
        return newVal;
      });
    }
    if (values.address == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t("string-literals.address-empty");
        return newVal;
      });
      validationFlag = true;
    } else if (values.address.length > 255) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t(
          "string-literals.firm-address-length-exceeds"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (!addressRegex.test(values.address)) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t(
          "string-literals.firm-address-invalid"
        );
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = false;
        return newVal;
      });
    }
    if (values.country == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.country.error = true;
        newVal.hospitalDetails.country.msg = t("string-literals.country-empty");
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.country.error = false;
        return newVal;
      });
    }
    if (values.state == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.state.error = true;
        newVal.hospitalDetails.state.msg = t("string-literals.state-empty");
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.state.error = false;
        return newVal;
      });
    }
    if (values.city == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.city.error = true;
        newVal.hospitalDetails.city.msg = t("string-literals.city-empty");
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.city.error = false;
        return newVal;
      });
    }
    if (values.priorityCount === null || values.priorityCount === "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.priorityCount.error = true;
        newVal.hospitalDetails.priorityCount.msg = t(
          "string-literals.priority-count-empty"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (typeof +values.priorityCount != "number") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.priorityCount.error = true;
        newVal.hospitalDetails.priorityCount.msg = t(
          "string-literals.priority-count-integer"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (values.priorityCount < 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.priorityCount.error = true;
        newVal.hospitalDetails.priorityCount.msg = t(
          "string-literals.priority-count-negative"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (values.priorityCount > 500) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.priorityCount.error = true;
        newVal.hospitalDetails.priorityCount.msg = t(
          "string-literals.priority-count-max"
        );
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.priorityCount.error = false;
        return newVal;
      });
    }
    let validationError=validatePhoneNumberWithCode(values.customerSupportNumber,values.customerSupportNumberCountryCode,values.customerSupportNumberDialCode,t);
    if(validationError)  
    {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.hospitalDetails.customerSupportNumber.error = true;
          newVal.hospitalDetails.customerSupportNumber.msg = t("string-literals.customer-support-number-invalid");
          return newVal;
        })
        validationFlag = true;
    }else
    {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.customerSupportNumber.error = false;
        return newVal;
      });
    }
    if (validationFlag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } 
  };

   const validateProjectsDetails = (values) => {
    const nameRegex = /^[0-9a-zA-Z&._ -]+$/i;
    const addressRegex = /^[0-9a-zA-Z\s&#.\/,-]+$/i;
    let validationFlag = false;
    if (values.name == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t("string-literals.name-empty");
        return newVal;
      });
      validationFlag = true;
    } else if (values.name.length > 100) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t(
          "string-literals.firm-name-length-exceeds"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (!nameRegex.test(values.name)) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = true;
        newVal.hospitalDetails.name.msg = t(
          "string-literals.firm-name-invalid"
        );
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.name.error = false;
        return newVal;
      });
    }
    if (values.address == "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t("string-literals.address-empty");
        return newVal;
      });
      validationFlag = true;
    } else if (values.address.length > 255) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t(
          "string-literals.firm-address-length-exceeds"
        );
        return newVal;
      });
      validationFlag = true;
    } else if (!addressRegex.test(values.address)) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.hospitalDetails.address.error = true;
        newVal.hospitalDetails.address.msg = t(
          "string-literals.firm-address-invalid"
        );
        return newVal;
      });
      validationFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } 
  };

  const resetValues = (action) => {
    // console.log("Resetting Values");
    setErrorContactState(() => {
      let newVal = { ...errorContactState };
      newVal.hospitalDetails.name.error = false;
      newVal.hospitalDetails.address.error = false;
      newVal.hospitalDetails.country.error = false;
      newVal.hospitalDetails.state.error = false;
      newVal.hospitalDetails.city.error = false;
      newVal.contact1.name.error = false;
      newVal.contact1.email.error = false;
      newVal.contact1.type.error = false;
      newVal.contact1.mobile.error = false;
      newVal.contact1.landline.error = false;
      newVal.contact2.name.error = false;
      newVal.contact2.email.error = false;
      newVal.contact2.type.error = false;
      newVal.contact2.mobile.error = false;
      newVal.contact2.landline.error = false;
      newVal.contact3.name.error = false;
      newVal.contact3.email.error = false;
      newVal.contact3.type.error = false;
      newVal.contact3.mobile.error = false;
      newVal.contact3.landline.error = false;
      newVal.pacsNodeConfig.error = false;
      if (action == "EDIT") {
        // console.log("Resetting Values for EDIT");
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab3Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab4Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab5Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab6Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab7Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab8Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab17Status = {
          value: "Completed",
          color: "green",
        };
      } else if (action == "VIEW") {
        // console.log("Resetting Values for VIEW");
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab3Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab4Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab5Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab6Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab7Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab8Status = {
          value: "Completed",
          color: "green",
        };
        newVal.tabStatusInitialValue.tab17Status = {
          value: "Completed",
          color: "green",
        };
      } else {
        newVal.tabStatusInitialValue.tab1Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab3Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab4Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab5Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab6Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab7Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab8Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab9Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab10Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab11Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab12Status = {
          value: "Info",
          color: "#FF9900",
        };
        newVal.tabStatusInitialValue.tab17Status = {
          value: "Info",
          color: "#FF9900",
        };
      }

      return newVal;
    });
    return true;
  };

  const validateContactDto = (contact, contact1, contact2) => {
    let errors = {};
    const nameRegex = /^[0-9a-zA-Z&._ -]+$/i;
    const typeRegex = /^[0-9a-zA-Z&._ -]+$/i;
    const mobileRegex = /^[+]\d/i;

    //empty check
    if (
      contact.name === "" &&
      contact.email === "" &&
      contact.mobile === "" &&
      contact.landline === "" &&
      contact.type === ""
    ) {
      return errors;
    }

    //name validations
    if (contact.name === "") {
      errors = {
        ...errors,
        name: {
          error: true,
          msg: t("string-literals.name-empty"),
        },
      };
    } else if (contact.name.length > 100) {
      errors = {
        ...errors,
        name: {
          error: true,
          msg: t("string-literals.name-length-exceeds"),
        },
      };
    } else if (!nameRegex.test(contact.name)) {
      errors = {
        ...errors,
        name: {
          error: true,
          msg: t("string-literals.name-invalid"),
        },
      };
    }

    //email validations
    if (contact.email === "") {
      errors = {
        ...errors,
        email: {
          error: true,
          msg: t("string-literals.email-empty"),
        },
      };
    } else if (contact.email.length > 255) {
      errors = {
        ...errors,
        email: {
          error: true,
          msg: t("string-literals.email-length-exceeds"),
        },
      };
    } else if (!emailCorrect(contact.email)) {
      errors = {
        ...errors,
        email: {
          error: true,
          msg: t("string-literals.email-invalid"),
        },
      };
    } else if (
      contact.email === contact1?.email ||
      contact.email === contact2?.email
    ) {
      errors = {
        ...errors,
        email: {
          error: true,
          msg: t("string-literals.duplicate-email"),
        },
      };
    } 

    //type validations
    if (contact.type === "") {
      errors = {
        ...errors,
        type: {
          error: true,
          msg: t("string-literals.type-empty"),
        },
      };
    } else if (contact.type.length > 50) {
      errors = {
        ...errors,
        type: {
          error: true,
          msg: t("string-literals.type-length-exceeds"),
        },
      };
    } else if (!typeRegex.test(contact.type)) {
      errors = {
        ...errors,
        type: {
          error: true,
          msg: t("string-literals.type-invalid"),
        },
      };
    }

    //mobile validations
    if (contact.mobile === "") {
      errors = {
        ...errors,
        mobile: {
          error: true,
          msg: t("string-literals.mobile-empty"),
        },
      };
    } else if (!mobileRegex.test(contact.mobile)) {
      errors = {
        ...errors,
        mobile: {
          error: true,
          msg: t("string-literals.mobile-invalid"),
        },
      };
    } else {
      const validationError = validatePhoneNumberWithCode(
        contact.mobile,
        contact.mobileCountryCode,
        contact.mobileDialCode,
        t
      );
      if (validationError) {
        errors = {
          ...errors,
          mobile: {
            error: true,
            msg: validationError,
          },
        };
      }
    }

    //landline validations
    if (contact.landline === "") {
      errors = {
        ...errors,
        landline: {
          error: true,
          msg: t("string-literals.landline-empty"),
        },
      };
    } else if (!mobileRegex.test(contact.landline)) {
      errors = {
        ...errors,
        landline: {
          error: true,
          msg: t("string-literals.landline-invalid"),
        },
      };
    } else {
      const validationError = validatePhoneNumberWithCode(
        contact.landline,
        contact.landlineCountryCode,
        contact.landlineDialCode,
        t
      );
      if (validationError) {
        errors = {
          ...errors,
          landline: {
            error: true,
            msg: validationError,
          },
        };
      }
    }

    return errors;
  };

  const validateChannels = (values) => {
  // defensive
  values = values || {};

  console.log("validateChannels:", {
    enableEmail: values.enableEmail,
    enableWhatsApp: values.enableWhatsApp,
    notificationEmail: values.notificationEmail,
    whatsappNumber: values.whatsappNumber,
  });

  // clear only contactChannel (do NOT touch contact1/2/3)
  setErrorContactState(prev => ({
    ...prev,
    contactChannel: {
      error: false,
      msg: "",
      notificationEmail: { error: false, msg: "" },
      whatsappNumber: { error: false, msg: "" }
    }
  }));

  // 1) If both channels disabled -> choose-one error
  if (!values.enableEmail &&  !values.enableWhatsApp && roles[0] != "FIRM_ADMIN") {
    setErrorContactState(prev => ({
      ...prev,
      contactChannel: {
        error: true,
        msg: t("string-literals.choose-email-or-whatsapp") || "Choose either Email or WhatsApp (or both).",
        notificationEmail: { error: false, msg: "" },
        whatsappNumber: { error: false, msg: "" }
      }
    }));
    return false;
  }
  

  // Validate enabled channels but DO NOT return at the first failure.
  //const nextChannelState = { ...(errorContactState?.contactChannel || {}) };
  const nextChannelState = {
    error: false,
    msg: "",
    notificationEmail: { error: false, msg: "" },
    whatsappNumber: { error: false, msg: "" }
  };
  let ok = true;

  // if (values.enableEmail) {
  //   const email = (values.notificationEmail || "").trim();
  //   if (!email) {
  //     nextChannelState.notificationEmail = { error: true, msg: t("string-literals.email-empty") || "Email cannot be blank" };
  //     ok = false;
  //   } else if (!emailCorrect(email)) {
  //     nextChannelState.notificationEmail = { error: true, msg: t("string-literals.email-invalid") || "Email is invalid" };
  //     ok = false;
  //   } else {
  //     nextChannelState.notificationEmail = { error: false, msg: "" };
  //   }
  // } else {
  //   nextChannelState.notificationEmail = { error: false, msg: "" };
  // }
    if (values.enableEmail) {
    const email = (values.notificationEmail || "").trim();

    // Allow blank email when enabled → NO ERROR
    if (email === "") {
        nextChannelState.notificationEmail = { error: false, msg: "" };
    }
    // Validate format only if not blank
    else if (!emailCorrect(email)) {
        nextChannelState.notificationEmail = {
            error: true,
            msg: t("string-literals.email-invalid") || "Email is invalid"
        };
        ok = false;
    } 
    else {
        nextChannelState.notificationEmail = { error: false, msg: "" };
    }
} 
else {
    nextChannelState.notificationEmail = { error: false, msg: "" };
}

  // 2) email (if enabled)
  // if (values.enableEmail) {
  //   const email = (values.notificationEmail || "").trim();
  //   if (!email) {
  //     setErrorContactState(prev => ({
  //       ...prev,
  //       contactChannel: {
  //         ...(prev?.contactChannel || {}),
  //         notificationEmail: { error: true, msg: t("string-literals.email-empty") || "Email cannot be blank" },
  //         error: false,
  //         msg: ""
  //       }
  //     }));
  //     return false;
  //   }
  //   if (!emailCorrect(email)) {
  //     setErrorContactState(prev => ({
  //       ...prev,
  //       contactChannel: {
  //         ...(prev?.contactChannel || {}),
  //         notificationEmail: { error: true, msg: t("string-literals.email-invalid") || "Email is invalid" },
  //         error: false,
  //         msg: ""
  //       }
  //     }));
  //     return false;
  //   }

  //   // if ok, clear notificationEmail error
  //   setErrorContactState(prev => ({
  //     ...prev,
  //     contactChannel: {
  //       ...(prev?.contactChannel || {}),
  //       notificationEmail: { error: false, msg: "" },
  //       error: false,
  //       msg: ""
  //     }
  //   }));
  // }

  // 3) whatsapp (if enabled)
  // if (values.enableWhatsApp) {
  //   const num = (values.whatsappNumber || "").trim();
  //   if (!num) {
  //     setErrorContactState(prev => ({
  //       ...prev,
  //       contactChannel: {
  //         ...(prev?.contactChannel || {}),
  //         whatsappNumber: { error: true, msg: t("string-literals.whatsapp-number-empty") || "WhatsApp number cannot be blank" },
  //         error: false,
  //         msg: ""
  //       }
  //     }));
  //     return false;
  //   }
  //   if (!num.startsWith("+")) {
  //     setErrorContactState(prev => ({
  //       ...prev,
  //       contactChannel: {
  //         ...(prev?.contactChannel || {}),
  //         whatsappNumber: { error: true, msg: t("string-literals.whatsapp-number-invalid") || "WhatsApp number invalid" },
  //         error: false,
  //         msg: ""
  //       }
  //     }));
  //     return false;
  //   }

  //   // valid -> clear whatsappNumber error
  //   setErrorContactState(prev => ({
  //     ...prev,
  //     contactChannel: {
  //       ...(prev?.contactChannel || {}),
  //       whatsappNumber: { error: false, msg: "" },
  //       error: false,
  //       msg: ""
  //     }
  //   }));
  // }

  // passed channel checks
  //return true;
  // if (values.enableWhatsApp) {
  //   const num = (values.whatsappNumber || "").trim();
  //   if (!num) {
  //     nextChannelState.whatsappNumber = { error: true, msg: t("string-literals.whatsapp-number-empty") || "WhatsApp number cannot be blank" };
  //     ok = false;
  //   } else if (!num.startsWith("+")) {
  //     nextChannelState.whatsappNumber = { error: true, msg: t("string-literals.whatsapp-number-invalid") || "WhatsApp number invalid" };
  //     ok = false;
  //   } else {
  //     nextChannelState.whatsappNumber = { error: false, msg: "" };
  //   }
  // } else {
  //   nextChannelState.whatsappNumber = { error: false, msg: "" };
  // }
  if (isEnableWhatsApp && values.enableWhatsApp) {
    const num = (values.whatsappNumber || "").trim();

    // Allow blank WhatsApp number when enabled → NO ERROR
    if (num === "") {
        nextChannelState.whatsappNumber = { error: false, msg: "" };
    }
    // Validate format only if not blank
    else if (!num.startsWith("+")) {
        nextChannelState.whatsappNumber = {
            error: true,
            msg: t("string-literals.whatsapp-number-invalid") || "WhatsApp number invalid"
        };
        ok = false;
    } 
    else {
        nextChannelState.whatsappNumber = { error: false, msg: "" };
    }
} 
else {
    nextChannelState.whatsappNumber = { error: false, msg: "" };
}


  // If any sub-error exists, we show the sub-errors but not the choose-one msg.
  nextChannelState.error = false;
  nextChannelState.msg = "";

  // commit once
  setErrorContactState(prev => ({
    ...prev,
    contactChannel: nextChannelState
  }));
  return ok;
};



  const validateContact = (values) => {
    if (!validateChannels(values)) {
  // channel validation failed; do not continue to per-contact validation
  return false;
}
    let contactErrorFlag = false;

    const errorsContact1 = validateContactDto(
      values.contact1,
      values.contact2,
      values.contact3
    );
    const errorsContact2 = validateContactDto(
      values.contact2,
      values.contact1,
      values.contact3
    );
    const errorsContact3 = validateContactDto(
      values.contact3,
      values.contact1,
      values.contact2
    );
    if (Object.keys(errorsContact1).length !== 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (errorsContact1?.name) {
          newVal.contact1.name = errorsContact1?.name;
        }
        if (errorsContact1?.email) {
          newVal.contact1.email = errorsContact1?.email;
        }
        if (errorsContact1?.type) {
          newVal.contact1.type = errorsContact1?.type;
        }
        if (errorsContact1?.mobile) {
          newVal.contact1.mobile = errorsContact1?.mobile;
        }
        if (errorsContact1?.landline) {
          newVal.contact1.landline = errorsContact1?.landline;
        }
        newVal.contact1.errorState = true;
        return newVal;
      });
      contactErrorFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.contact1.name.error = false;
        newVal.contact1.type.error = false;
        newVal.contact1.email.error = false;
        newVal.contact1.mobile.error = false;
        newVal.contact1.landline.error = false;
        newVal.contact1.errorState = false;
        return newVal;
      });
    }

    if (Object.keys(errorsContact2).length !== 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (errorsContact2?.name) {
          newVal.contact2.name = errorsContact2?.name;
        }
        if (errorsContact2?.email) {
          newVal.contact2.email = errorsContact2?.email;
        }
        if (errorsContact2?.type) {
          newVal.contact2.type = errorsContact2?.type;
        }
        if (errorsContact2?.mobile) {
          newVal.contact2.mobile = errorsContact2?.mobile;
        }
        if (errorsContact2?.landline) {
          newVal.contact2.landline = errorsContact2?.landline;
        }
        newVal.contact2.errorState = true;
        return newVal;
      });
      contactErrorFlag = true;
    } else {
      console.log(errorContactState);
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.contact2.name.error = false;
        newVal.contact2.type.error = false;
        newVal.contact2.email.error = false;
        newVal.contact2.mobile.error = false;
        newVal.contact2.landline.error = false;
        newVal.contact2.errorState = false;
        return newVal;
      });
    }

    if (Object.keys(errorsContact3).length !== 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        if (errorsContact3?.name) {
          newVal.contact3.name = errorsContact3?.name;
        }
        if (errorsContact3?.email) {
          newVal.contact3.email = errorsContact3?.email;
        }
        if (errorsContact2?.type) {
          newVal.contact3.type = errorsContact3?.type;
        }
        if (errorsContact3?.mobile) {
          newVal.contact3.mobile = errorsContact3?.mobile;
        }
        if (errorsContact3?.landline) {
          newVal.contact3.landline = errorsContact3?.landline;
        }
        newVal.contact3.errorState = true;
        return newVal;
      });
      contactErrorFlag = true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.contact3.name.error = false;
        newVal.contact3.type.error = false;
        newVal.contact3.email.error = false;
        newVal.contact3.mobile.error = false;
        newVal.contact3.landline.error = false;
        newVal.contact3.errorState = false;
        return newVal;
      });
    }

    if (!contactErrorFlag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab2Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return false;
    }
  };

  const validateHospitalSettings = (values, action) => {
    let flag = true;
    let settingsFlag = true;
    let otherReportSettingsFlag = true;
     // === master/sub flags validation ===
    if (values.allowFirmAdminSetClientComm) {
      if (!values.firmAdminCanEnableWhatsapp && !values.firmAdminCanEnableEmail) {
        console.log("%c[VALIDATOR] Communication flag validation failed", "color: red; font-weight: bold;");
        setErrorContactState(() => {
          const newVal = { ...errorContactState };

          // Attach error under settings → consistent with other validation errors
          newVal.settings.masterClientComm.error = true;
          newVal.settings.masterClientComm.msg = ("Choose either one of the choice or deselect the master flag");
          return newVal;
        });
        flag=false;
        settingsFlag = false;
      }else{
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.masterClientComm = false;
          return newVal;
        });
      }
    }
    // if (values.autoAssignEnable) {
    //   if (values.autoAssignModalityIds.length === 0) {
    //     setErrorContactState(() => {
    //       const newVal = { ...errorContactState };
    //       newVal.settings.autoAssignModalityIds.error = true;
    //       newVal.settings.autoAssignModalityIds.msg = t(
    //         "string-literals.auto-assign-modalities-required"
    //       );
    //       return newVal;
    //     });
    //     flag = false;
    //   } else {
    //     setErrorContactState(() => {
    //       const newVal = { ...errorContactState };
    //       newVal.settings.autoAssignModalityIds.error = false;
    //       return newVal;
    //     });
    //   }
    // }
    if (values?.qcEnabled || values?.preliminaryQcEnabled) {
      if (values?.modalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.modalityIds.error = true;
          newVal.settings.modalityIds.msg = t(
            "string-literals.qc-enabled-modalities-required"
          );
          return newVal;
        });
        flag = false;
        settingsFlag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.modalityIds.error = false;
          return newVal;
        });
      }
    }
    if (values?.historyAvailable) {
      if (values?.historyModalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.historyModalityIds.error = true;
          newVal.settings.historyModalityIds.msg = t(
            "string-literals.history-enabled-modalities-required"
          );
          return newVal;
        });
        flag = false;
        settingsFlag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.historyModalityIds.error = false;
          return newVal;
        });
      }
    }
    if (values?.enableUnassignmentService) {
      if (!values?.unassignmentModalityIds || values.unassignmentModalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.unassignmentModalityIds.error = true;
          newVal.settings.unassignmentModalityIds.msg = t(
            "string-literals.unassignment-modalities-required"
          );
          return newVal;
        });
        flag = false;
        settingsFlag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.unassignmentModalityIds.error = false;
          return newVal;
        });
      }
    }
    if (values?.accountWarning?.length > 1000) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.settings.accountWarning.error = true;
        newVal.settings.accountWarning.msg = t(
          "string-literals.account-warning-length-exceeds"
        );
        return newVal;
      });
      flag = false;
      settingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.settings.accountWarning.error = false;
        return newVal;
      });
    }

    const secondSignatureText =
      values?.signature2Dto?.signature2Text ??
      values?.signature2Dto?.signatureText ??
      "";
    const thirdSignatureText =
      values?.signature3Dto?.signature3Text ??
      values?.signature3Dto?.signatureText ??
      "";

    if (secondSignatureText.length > 100) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.signature2Dto.signature2Text.error = true;
        newVal.otherReportSettings.signature2Dto.signature2Text.msg = t(
          "string-literals.second-signature-length-exceeds"
        );
        return newVal;
      });
      flag = false;
      otherReportSettingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.signature2Dto.signature2Text.error = false;
        newVal.otherReportSettings.signature2Dto.signature2Text.msg = "";
        return newVal;
      });
    }

    if (thirdSignatureText.length > 100) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.signature3Dto.signature3Text.error = true;
        newVal.otherReportSettings.signature3Dto.signature3Text.msg = t(
          "string-literals.third-signature-length-exceeds"
        );
        return newVal;
      });
      flag = false;
      otherReportSettingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.signature3Dto.signature3Text.error = false;
        newVal.otherReportSettings.signature3Dto.signature3Text.msg = "";
        return newVal;
      });
    }

    if (typeof +values?.studyLinkExpiryTime != "number") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.settings.studyLinkExpiryTime.error = true;
        newVal.settings.studyLinkExpiryTime.msg = t(
          "string-literals.study-link-expiry-invalid"
        );
        return newVal;
      });
      flag = false;
      settingsFlag = false;
    } else if (+values?.studyLinkExpiryTime <= 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.settings.studyLinkExpiryTime.error = true;
        newVal.settings.studyLinkExpiryTime.msg = t(
          "string-literals.study-link-expiry-less-than-zero"
        );
        return newVal;
      });
      flag = false;
      settingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.settings.studyLinkExpiryTime.error = false;
        newVal.settings.studyLinkExpiryTime.msg = "";
        return newVal;
      });
    }

    if (typeof +values?.reportLinkExpiryTime != "number") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.reportLinkExpiryTime.error = true;
        newVal.otherReportSettings.reportLinkExpiryTime.msg = t(
          "string-literals.report-link-expiry-invalid"
        );
        return newVal;
      });
      flag = false;
      otherReportSettingsFlag = false;
    } else if (+values?.reportLinkExpiryTime < 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.reportLinkExpiryTime.error = true;
        newVal.otherReportSettings.reportLinkExpiryTime.msg = t(
          "string-literals.report-link-expiry-less-than-zero"
        );
        return newVal;
      });
      flag = false;
      otherReportSettingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.reportLinkExpiryTime.error = false;
        newVal.otherReportSettings.reportLinkExpiryTime.msg = "";
        return newVal;
      });
    }

    if (values?.addPrintDisclaimer) {
      if (values?.printDisclaimerText.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.printDisclaimerText.error = true;
          newVal.settings.printDisclaimerText.msg = t(
            "string-literals.print-disclaimer-empty"
          );
          return newVal;
        });
        flag = false;
        settingsFlag = false;
      } else if (values?.printDisclaimerText.length > 500) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.printDisclaimerText.error = true;
          newVal.settings.printDisclaimerText.msg = t(
            "string-literals.print-disclaimer-length-exceeds"
          );
          return newVal;
        });
        flag = false;
        settingsFlag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.settings.printDisclaimerText.error = false;
          return newVal;
        });
      }
    }

    if (values?.addendumDisclaimerEnabled) {
      if (
        values?.addendumDisclaimerText === "" ||
        values?.addendumDisclaimerText === null ||
        values?.addendumDisclaimerText === undefined
      ) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherReportSettings.addendumDisclaimerText.error = true;
          newVal.otherReportSettings.addendumDisclaimerText.msg = t(
            "string-literals.addendum-disclaimer-empty"
          );
          return newVal;
        });
        flag = false;
        otherReportSettingsFlag = false;
      } else if (values?.addendumDisclaimerText.length > 500) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherReportSettings.addendumDisclaimerText.error = true;
          newVal.otherReportSettings.addendumDisclaimerText.msg = t(
            "string-literals.addendum-disclaimer-length-exceeds"
          );
          return newVal;
        });
        flag = false;
        otherReportSettingsFlag = false;
      } else {
        // if (values.addendumDisclaimerText.match(SPECIALCHAR_UNICODE_REGEX)) {
        //   values.addendumDisclaimerText = values.addendumDisclaimerText.replace(SPECIALCHAR_UNICODE_REGEX, '');
        //   showToastv2(
        //     TOAST_TYPE.INFO,
        //     t("string-literals.removed-special-characters")
        //   );
        // }
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherReportSettings.addendumDisclaimerText.error = false;
          newVal.otherReportSettings.addendumDisclaimerText.msg = "";
          return newVal;
        });
      }
    }

    if (!values?.emailPDF && !values?.emailDOCX) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.emailFormat.error = true;
        newVal.otherReportSettings.emailFormat.msg = "At least one email format (PDF or DOCX) must be selected.";
        return newVal;
      });
      flag = false;
      otherReportSettingsFlag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.otherReportSettings.emailFormat.error = false;
        newVal.otherReportSettings.emailFormat.msg = "";
        return newVal;
      });
    }

    if(isBucketManagement){
      if (action === ACTIONS.ADD) {
        // if (
        //   !values.modalityBuckets.some((m) => m.modality === "DEFAULT") || // DEFAULT missing
        //   values.modalityBuckets.some((m) => m.modality === "DEFAULT" && !m.bucketConfiguration) // DEFAULT present but no bucket
        // ) {
        //   setErrorContactState(() => {
        //     const newVal = { ...errorContactState };
        //     newVal.settings.modalityBuckets = {
        //       error: true,
        //       msg: t("string-literals.default-modality-required"),
        //     };
        //     return newVal;
        //   });
        //   flag = false;
        // }else 
        if (
          values.modalityBuckets.some((m) => m.modality && !m.bucketConfiguration)
          ) {
            setErrorContactState(() => {
              const newVal = { ...errorContactState };
              newVal.settings.modalityBuckets = {
                error: true,
                msg: t("string-literals.bucket-required-for-modality"), // add this translation key
              };
              return newVal;
            });
            flag = false;
            settingsFlag = false;
        } else {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.settings.modalityBuckets = {
              error: false,
              msg: "",
            };
            return newVal;
          });
        }
       }else if (action === ACTIONS.EDIT) {
        const hasBuckets = values.modalityBuckets.some(
          (m) => m.modality || m.bucketConfiguration
        );
        const defaultEntry = values.modalityBuckets.find((m) => m.modality === "DEFAULT");

        if (
          hasBuckets && 
          (!defaultEntry || !defaultEntry.bucketConfiguration) // require DEFAULT with value
        ) {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.settings.modalityBuckets = {
              error: true,
              msg: t("string-literals.default-modality-required"),
            };
            return newVal;
          });
          flag = false;
          settingsFlag = false;
        }else if (
          values.modalityBuckets.some((m) => m.modality && !m.bucketConfiguration)
          ) {
            setErrorContactState(() => {
              const newVal = { ...errorContactState };
              newVal.settings.modalityBuckets = {
                error: true,
                msg: t("string-literals.bucket-required-for-modality"), // add this translation key
              };
              return newVal;
            });
            flag = false;
            settingsFlag = false;
        } else {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.settings.modalityBuckets = {
              error: false,
              msg: "",
            };
            return newVal;
          });
        }
      }
    }

    setErrorContactState(() => {
      const newVal = { ...errorContactState };
      newVal.tabStatusInitialValue.tab5Status = otherReportSettingsFlag
        ? {
            value: "Completed",
            color: "green",
          }
        : {
            value: "Info",
            color: "red",
          };
      newVal.tabStatusInitialValue.tab6Status = settingsFlag
        ? {
            value: "Completed",
            color: "green",
          }
        : {
            value: "Info",
            color: "red",
          };
      return newVal;
    });
    return flag;
  };

  const validateConfigureSettings = (values, action) => {
    let flag = true;
   

    if (values.addPrintDisclaimer) {
      if (
        values.printDisclaimerText === "" ||
        values.printDisclaimerText === null ||
        values.printDisclaimerText === undefined
      ) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.configureSettings.printDisclaimerText.error = true;
          newVal.configureSettings.printDisclaimerText.msg = t(
            "string-literals.print-disclaimer-empty"
          );
          return newVal;
        });
        flag = false;
      } else if (values.printDisclaimerText?.length > 500) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.configureSettings.printDisclaimerText.error = true;
          newVal.configureSettings.printDisclaimerText.msg = t(
            "string-literals.print-disclaimer-length-exceeds"
          );
          return newVal;
        });
        flag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.configureSettings.printDisclaimerText.error = false;
          return newVal;
        });
      }
    }

    if (values.accountWarning?.length > 1000) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.accountWarning.error = true;
        newVal.configureSettings.accountWarning.msg = t(
          "string-literals.account-warning-length-exceeds"
        );
        return newVal;
      });
      flag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.accountWarning.error = false;
        return newVal;
      });
    }

    if (values.priorityCount === null || values.priorityCount === "") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.priorityCount.error = true;
        newVal.configureSettings.priorityCount.msg = t(
          "string-literals.priority-count-empty"
        );
        return newVal;
      });
      flag = false;
    } else if (typeof +values.priorityCount != "number") {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.priorityCount.error = true;
        newVal.configureSettings.priorityCount.msg = t(
          "string-literals.priority-count-integer"
        );
        return newVal;
      });
      flag = false;
    } else if (values.priorityCount < 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.priorityCount.error = true;
        newVal.configureSettings.priorityCount.msg = t(
          "string-literals.priority-count-negative"
        );
        return newVal;
      });
      flag = false;
    } else if (values.priorityCount > 500) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.priorityCount.error = true;
        newVal.configureSettings.priorityCount.msg = t(
          "string-literals.priority-count-max"
        );
        return newVal;
      });
      flag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.priorityCount.error = false;
        return newVal;
      });
    }
    if (!values?.studyLinkExpiryTime || +values?.studyLinkExpiryTime <= 0) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.studyLinkExpiryTime = {
          error: true,
          msg: t("string-literals.study-link-expiry-less-than-zero"),
        };
        return newVal;
      });
      flag = false;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.configureSettings.studyLinkExpiryTime = {
          error: false,
          msg: "",
        };
        return newVal;
      });
    }

    if(isBucketManagement){
      if (action === ACTIONS.ADD) {
        // if (
        //   !values.modalityBuckets.some((m) => m.modality === "DEFAULT") || // DEFAULT missing
        //   values.modalityBuckets.some((m) => m.modality === "DEFAULT" && !m.bucketConfiguration) // DEFAULT present but no bucket
        // ) {
        //   setErrorContactState(() => {
        //     const newVal = { ...errorContactState };
        //     newVal.configureSettings.modalityBuckets = {
        //       error: true,
        //       msg: t("string-literals.default-modality-required"),
        //     };
        //     return newVal;
        //   });
        //   flag = false;
        // } else 
          if (
          values.modalityBuckets.some((m) => m.modality && !m.bucketConfiguration)
          ) {
            setErrorContactState(() => {
              const newVal = { ...errorContactState };
              newVal.configureSettings.modalityBuckets = {
                error: true,
                msg: t("string-literals.bucket-required-for-modality"), // add this translation key
              };
              return newVal;
            });
            flag = false;
        } else {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.configureSettings.modalityBuckets = {
              error: false,
              msg: "",
            };
            return newVal;
          });
        }
      }else if (action === ACTIONS.EDIT) {
        const hasBuckets = values.modalityBuckets.some(
          (m) => m.modality || m.bucketConfiguration
        );
        const defaultEntry = values.modalityBuckets.find((m) => m.modality === "DEFAULT");

        if (
          hasBuckets && 
          (!defaultEntry || !defaultEntry.bucketConfiguration) // require DEFAULT with value
        ) {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.configureSettings.modalityBuckets = {
              error: true,
              msg: t("string-literals.default-modality-required"),
            };
            return newVal;
          });
          flag = false;
        } else if (
          values.modalityBuckets.some((m) => m.modality && !m.bucketConfiguration)
          ) {
            setErrorContactState(() => {
              const newVal = { ...errorContactState };
              newVal.configureSettings.modalityBuckets = {
                error: true,
                msg: t("string-literals.bucket-required-for-modality"), // add this translation key
              };
              return newVal;
            });
            flag = false;
        } else {
          setErrorContactState(() => {
            const newVal = { ...errorContactState };
            newVal.configureSettings.modalityBuckets = {
              error: false,
              msg: "",
            };
            return newVal;
          });
        }
      }
    }

    if (flag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab9Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab9Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return false;
    }
  };

  const validateOtherSettings = (values) => {
    let flag = true;
    // if (values.autoAssignEnable) {
    //   if (values.autoAssignModalityIds.length === 0) {
    //     setErrorContactState(() => {
    //       const newVal = { ...errorContactState };
    //       newVal.otherSettings.autoAssignModalityIds.error = true;
    //       newVal.otherSettings.autoAssignModalityIds.msg = t(
    //         "string-literals.auto-assign-modalities-required"
    //       );
    //       return newVal;
    //     });
    //     flag = false;
    //   }
    // }
    if (values.qcEnabled || values.preliminaryQcEnabled) {
      if (values.modalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherSettings.modalityIds.error = true;
          newVal.otherSettings.modalityIds.msg = t(
            "string-literals.qc-enabled-modalities-required"
          );
          return newVal;
        });
        flag = false;
        // } else {
        //   setErrorContactState(() => {
        //     const newVal = { ...errorContactState };
        //     newVal.otherSettings.modalityIds.error = false;
        //     newVal.otherSettings.modalityIds.msg = t(
        //       "string-literals.qc-enabled-modalities-required"
        //     );
        //     return newVal;
        //   });
      }
    }
    if (values.historyAvailable) {
      if (values.historyModalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherSettings.historyModalityIds.error = true;
          newVal.otherSettings.historyModalityIds.msg = t(
            "string-literals.auto-assign-modalities-required"
          );
          return newVal;
        });
        flag = false;
        // } else {
        //   setErrorContactState(() => {
        //     const newVal = { ...errorContactState };
        //     newVal.otherSettings.historyModalityIds.error = false;
        //     newVal.otherSettings.historyModalityIds.msg = t(
        //       "string-literals.auto-assign-modalities-required"
        //     );
        //     return newVal;
        //   });
      }
    }
     if (values.firmEnableUnassignmentService) {
      if (!values.unassignmentModalityIds || values.unassignmentModalityIds.length === 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.otherSettings.unassignmentModalityIds.error= true;
          newVal.otherSettings.unassignmentModalityIds = {
            error: true,
            msg: t("string-literals.unassignment-modalities-required")
          };
          return newVal;
        });
        flag = false;
      // } else {
      //   setErrorContactState(() => {
      //     const newVal = { ...errorContactState };
      //     newVal.otherSettings.unassignmentModalityIds = {
      //       error: false,
      //       msg: ""
      //     };
      //     return newVal;
      //   });
      }
    }

    if (flag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab10Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab10Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return false;
    }
  };

  const validateAutoAssignmentSettings = (
    values,
    selectedModalityAndSubModality
  ) => {
    let flag = true;
    if (values.autoAssignEnable) {
      if (selectedModalityAndSubModality.length == 0) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.autoAssignSettings.autoAssignModalityIds.error = true;
          newVal.autoAssignSettings.autoAssignModalityIds.msg = t(
            "string-literals.auto-assign-modalities-required"
          );
          return newVal;
        });
        flag = false;
      } else if (
        values.pediatricAssignmentEnabled &&
        values.selectedPediatricModalityId.length == 0
      ) {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.autoAssignSettings.pediatricModalityIds.error = true;
          newVal.autoAssignSettings.pediatricModalityIds.msg = t(
            "string-literals.auto-assign-modalities-required"
          );
          return newVal;
        });
        flag = false;
      } else {
        setErrorContactState(() => {
          const newVal = { ...errorContactState };
          newVal.autoAssignSettings.autoAssignModalityIds.error = false;
          newVal.autoAssignSettings.pediatricModalityIds.error = false;
          return newVal;
        });
      }
    }
    if (flag) {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab13Status = {
          value: "Completed",
          color: "green",
        };
        return newVal;
      });
      return true;
    } else {
      setErrorContactState(() => {
        const newVal = { ...errorContactState };
        newVal.tabStatusInitialValue.tab13Status = {
          value: "Info",
          color: "red",
        };
        return newVal;
      });
      return false;
    }
  };

  const validatePacsNode = (pacsNodeList) => {
    let flag = false;
    let errorMessage = "";
    if (pacsNodeList && pacsNodeList.length > 0) {
      flag = pacsNodeList.some(pacs => {
        const { name, aeTitle, hostname, port, description } = pacs;
        const isNameEmpty = name.trim() === '';
        const isAETitleEmpty = aeTitle.trim() === '';
        const isHostnameEmpty = hostname.trim() === '';
        const isPortEmpty = port.trim() === '';
  
        const isNameTooLong = name.length > 100;
        const isAETitleTooLong = aeTitle.length > 100;
        const isHostnameTooLong = hostname.length > 100;
        const isDescriptionTooLong = description.length > 100;
        const isportTooLong = port.length > 5;
  
        if (isNameEmpty || isAETitleEmpty || isHostnameEmpty || isPortEmpty) {
          errorMessage = t("string-literals.pacs-config-required")
          return true;
        }
  
        if (isNameTooLong || isAETitleTooLong || isHostnameTooLong || isDescriptionTooLong || isportTooLong) {
          errorMessage = t("string-literals.pacs-config-length")
          return true;
        }
  
        return false;
      });
    }
  
    // Set error state based on flag
    setErrorContactState(prevState => {
      const newVal = { ...prevState };
      if (flag) {
        newVal.pacsNodeConfig.error = true;
        newVal.pacsNodeConfig.msg = errorMessage;
        newVal.tabStatusInitialValue.tab17Status = { value: "Info", color: "red" };
      } else {
        newVal.pacsNodeConfig.error = false;
        newVal.tabStatusInitialValue.tab17Status = { value: "Completed", color: "green" };
      }
      return newVal;
    });
  
    return !flag;
  };

  return (
    <FirmContext.Provider
      value={{
        errorContactState,
        setErrorContactState,
        validateContact,
        validateHospitalDetails,
        validateHospitalSettings,
        setTabStatus,
        tabStatus,
        resetValues,
        validateConfigureSettings,
        validateOtherSettings,
        setFirmGlobalErrorState,
        firmGlobalErrorState,
        validateAutoAssignmentSettings,
        validatePacsNode,
        validateChannels,
        validateProjectsDetails
      }}
    >
      {props.children}
    </FirmContext.Provider>
  );
};

export default FirmState;
